import { FormikProps, useFormik } from 'formik';
import { getAddAppVariableFormValidation } from './FormikData';
import { useTranslation } from 'react-i18next';
import { FormikValues } from 'formik/dist/types';
import { IAppVariable } from '../../../../types/interfaces/app-variable';
import { usePostPutAppVariable } from '../../../../services/redux/api/appConfigApi';
import { AppVariableType } from '../../../../shared/constants';

export function useAppVariableComponent(
  onClose: () => void,
  appVariable?: IAppVariable,
) {
  const { t } = useTranslation();
  const [postPutAppVariable, { isLoading }] = usePostPutAppVariable();

  const formik: FormikProps<any> = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validationSchema: getAddAppVariableFormValidation(t),
    initialValues: {
      key: appVariable?.key || '',
      value: appVariable?.value || '',
      type: appVariable?.type || AppVariableType.string,
      isPrivate: appVariable?.isPrivate ?? true,
    },
    onSubmit: onSubmit,
  });

  function onSubmit(values: FormikValues) {
    postPutAppVariable({
      id: appVariable?.id,
      body: {
        key: values.key,
        value: values.value,
        type: values.type,
        isPrivate: values.isPrivate,
      },
    }).then((r) => {
      if (!('error' in r)) {
        onClose();
      }
    });
  }

  return {
    formik,
    isLoading,
  };
}
